import { NotificationCard } from '../../components/Card';
import { Flex, Button, Icon, Center } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { decode } from 'js-base64';
import { NotificationTime } from '../../components/Time';
import { Calendar } from '@kula-ai/icons/outline/Calendar';
import {
  RequisitionDetailsSection,
  RequisitionDetailsList,
} from '../requisition-notifications/components';

const CandidateAvailabilityUpdated = ({
  notification = {},
  onClose = () => {},
}) => {
  const { custom_attributes } = notification;
  let data = {};
  if (custom_attributes) {
    data = JSON.parse(decode(custom_attributes));
  }
  const { availability, job, candidate } = data;

  const detailsData = [
    { label: 'Position', value: job?.name },
    { label: 'Interview', value: availability?.name },
  ].filter((item) => item.value);

  const handleSeeAvailability = () => {
    if (availability?.url) {
      window.open(availability.url, '_self');
      onClose();
    }
  };

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="primary-100">
        <Icon as={Calendar} color="primary-500" width="16px" />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start" flex="1">
        <Flex wrap="wrap" alignItems="center" gap={1}>
          <KText size="sm-bold" color="secondary-900">
            {candidate?.name}
          </KText>
          <KText>have updated their availability for</KText>
          <KText size="sm-bold" color="primary-600">
            {availability?.name}
          </KText>
          <KText>in</KText>
          <KText
            size="sm-bold"
            color="primary-600"
            cursor="pointer"
            onClick={() => job?.url && window.open(job.url, '_self')}
          >
            {job?.name}
          </KText>
        </Flex>

        <RequisitionDetailsSection title="Details">
          <RequisitionDetailsList data={detailsData} />
        </RequisitionDetailsSection>

        <Button
          variant="primary"
          onClick={handleSeeAvailability}
          size="sm"
          w="fit-content"
          data-test-id="see-updated-availability-button"
        >
          See updated availability
        </Button>

        <NotificationTime notification={notification} />
      </Flex>
    </Flex>
  );
};

export const CandidateAvailabilityUpdatedNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <CandidateAvailabilityUpdated
        notification={notification}
        onClose={onClose}
      />
    </NotificationCard>
  );
};
